// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initBootstrapSwitch();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    app.initSpotlightJs();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();

    let form = require('./modules/form')();
    form.detectInputChange();
    form.formSetup();
    form.loadHashSection();
    form.getValues();
    form.initFormValidation();

    $(".megamenu").on("click", function(e) {
        e.stopPropagation();
    });

    $(".report-repair-form input[type='checkbox']").change(function(){
       $(this).parents('label').toggleClass('checked');
    });

    $('#accommodation-enquiry').on('shown.bs.collapse', function () {
        this.scrollIntoView();
    });

    $('form #accommodation_id').change(function(){

        $.ajax({
            url: '/accommodation-numbers',
            method: 'post',
            data: { id: $(this).val() },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).then(function (html) {
            $('#address-numbers-container').html(html).removeClass('d-none');
        });
    });

});



$.fn.serializeControls = function() {
    var data = {};

    function buildInputObject(arr, val) {
        if (arr.length < 1)
            return val;
        var objkey = arr[0];
        if (objkey.slice(-1) == "]") {
            objkey = objkey.slice(0, -1);
        }
        var result = {};
        if (arr.length == 1) {
            result[objkey] = val;
        } else {
            arr.shift();
            var nestedVal = buildInputObject(arr, val);
            result[objkey] = nestedVal;
        }
        return result;
    }

    $.each(this.serializeArray(), function() {
        var val = this.value;
        var c = this.name.split("[");

        // Initialize current data reference
        var currentData = data;
        for (var i = 0; i < c.length - 1; i++) {
            var key = c[i].replace("]", "");
            if (!currentData[key]) {
                currentData[key] = {};
            }
            currentData = currentData[key];
        }

        var lastKey = c[c.length - 1].replace("]", "");

        // If key already exists and it's not an array, convert it to an array
        if (currentData[lastKey] !== undefined) {
            if (!Array.isArray(currentData[lastKey])) {
                currentData[lastKey] = [currentData[lastKey]];
            }
            currentData[lastKey].push(val);
        } else {
            // Add a new key or convert it into an array if needed
            currentData[lastKey] = val;
        }
    });

    return data;
}

$.fn.isValid = function() {
    return this[0].checkValidity();
}

